import React from 'react';
import { createIcon } from '@chakra-ui/react';

const ArrowDownIcon = createIcon({
  displayName: 'ArrowDownIcon',
  viewBox: '4 4 15 15',
  path: (
    <>
      <path
        fill="currentColor"
        d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
      />
    </>
  ),
});

export default ArrowDownIcon;
